import React, { useEffect, useState } from "react";
import { Card, Col, Row, Tab, Tabs, Container } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import SurgirItemListWithIcon from "components/ui/SurgirItemListWithIcon/SurgirItemListWithIcon";
import SurgirListIcon from "components/ui/SurgirListIcon/SurgirListIcon";
import "./Transparency.scss";
import { ReactComponent as DownloadIcon } from './../../assets/images/Icons_descargar.svg'
import BannerTransparency from '../../assets/images/banner-transparencia.png'
import DownloadIconTab from '../../assets/images/Icons_descargar.svg'
const Chevron = 'images/transparency/transparency-chevron-right.svg'

const Transparency: React.FC = () => {
  const location = useLocation();
  const [tabName, setTabName] = useState('home')
  useEffect(() => {
    if (location.hash == '#Reclamos-y-Requerimientos') {
      setTabName('Reclamos-y-Requerimientos')
    } else {
      setTabName('home')
    }
  }, [])

  return (
    <div className="parrafo">
      <div className="boxi-t" >
        <Container>
          <div className="banner-container-banner" >
            <div className="banner-container-text">
              <span className="banner-text-banner"> Transparencia<br />
                <span className="banner-subText-banner">Tu confianza,<span className="subtitle_form"> nuestra prioridad.</span></span>
              </span>
            </div>
            <div>
              <img className="banner-image" src={BannerTransparency} alt="Banner Transparencia" fetchPriority='high' />
            </div>
          </div>
        </Container>

      </div>
      <div>
        <center>
          <div>
            <Container><br /> <br />
              <p><strong style={{ color: "#EC0000", fontSize: 24 }}>Hola!</strong>
                <br />
                Creemos que es importante que entiendas de una manera simple, ¿Cómo trataremos la información personal que nos brindaste?
                <br />
                Por eso, nos hemos propuesto hacerlo de una manera directa y con transparencia para que te sientas<br /><span > #informado, #seguro y #atendido. </span></p>
            </Container> </div> <br /></center>

        <Tabs
          activeKey={tabName}
          id="uncontrolled-tab-example"
          className="mb-5"
          onSelect={(key: any) => setTabName(key)}
          style={{ paddingLeft: "0", marginLeft: "8%", marginRight: "8%" }}
        >
          <Tab
            eventKey="home"
            title="Políticas"
            style={{ marginLeft: "10%", marginRight: "10%" }}
          >
            <Row>
              <Col md={4}>
                <p className="Columna">
                  Política de Privacidad
                </p>
              </Col>
              <Col md={8}>

                <Row style={{ marginTop: 10 }}>
                  <div className="card-style-transparence"  >
                    <div style={{ width: "100%" }}>
                      <span className="parrafo">
                        Política de Privacidad Santander EAFC

                      </span>
                    </div>
                    <div style={{ width: "40%" }}>
                      <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_POLITICA_PRIVACIDAD}
                        name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                    </div>
                  </div>


                </Row>
                <br />
                <br />
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <p className="Columna">
                  Política de Cookies
                </p>
              </Col>
              <Col md={8}>

                <Row style={{ marginTop: 10 }}>
                  <div className="card-style-transparence"  >
                    <div style={{ width: "100%" }}>
                      <span className="parrafo">
                        Política de Cookies de Fondos Colectivos
                      </span>
                    </div>
                    <div style={{ width: "40%" }}>
                      <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_POLITICA_COOKIES}
                        name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                    </div>
                  </div>
                </Row>
                <br /><br />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <p className="Columna">
                  Informativo de Videovigilancia
                </p>
              </Col>
              <Col md={8}>

                <Row style={{ marginTop: 10 }}>
                  <div className="card-style-transparence"  >
                    <div style={{ width: "100%" }}>
                      <span className="parrafo">

                        Informativo de Videovigilancia - Fondos Colectivos
                      </span>
                    </div>
                    <div style={{ width: "40%" }}>
                      <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_INFORMATIVO_VIDEOVIGILANCIA}
                        name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                    </div>
                  </div>
                </Row>
                <br />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <p className="Columna">
                  Proveedor de GPS              </p>
              </Col>
              <Col md={8}>

                <Row style={{ marginTop: 10 }}>
                  <div className="card-style-transparence"  >
                    <div style={{ width: "100%" }}>
                      <span className="parrafo">

                        Procedimiento selección de proveedor autorizado GPS particular
                      </span>
                    </div>
                    <div style={{ width: "40%" }}>
                      <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_SELECCION_GPS}
                        name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                    </div>
                  </div>
                </Row>
                <br />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <p className="Columna">
                  Inventario de Encargados de Tratamiento de Datos
                </p>
              </Col>
              <Col md={8}>

                <Row style={{ marginTop: 10 }}>
                  <div className="card-style-transparence"  >
                    <div style={{ width: "100%" }}>
                      <span className="parrafo">
                        Inventario de Encargados de Tratamiento de Datos
                      </span>
                    </div>
                    <div style={{ width: "40%" }}>
                      <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_INVENTARIO_ENCARGADOS_TRATAMIENTO}
                        name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                    </div>
                  </div>
                </Row>
                <br />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <p className="Columna">
                  Términos y Condiciones
                </p>
              </Col>

              <Col md={8}>
                <br />
                <span className="subtitulos"> CONDICIONES DE USO: </span>
                <br />
                <br />              Al ingresar a la presente Página Web de SANTANDER EMPRESA ADMINISTRADORA DE FONDOS COLECTIVOS S.A. (en adelante "FONDOS COLECTIVOS"), identificado con RUC N° 20612904040, con domicilio en AV. JAVIER PRADO ESTE NRO. 6210 INT. 501 URB. LA
                <br />RIVERA DE MONTERRICO II ETAPA, distrito de La Molina, provincia y departamento de Lima,  EL USUARIO (cliente de FONDOS COLECTIVOS) se compromete a leer la totalidad de los Términos y Condiciones generales que se detallan a continuación. En caso EL USUARIO no se encontrase de acuerdo con los mismos o de no aceptarlos, deberá abstenerse de navegar en la misma y/o manipular cualquier tipo de información vertida en él, bajo su responsabilidad. En consecuencia, todas las visitas que realice EL USUARIO, en esta página, así como sus efectos jurídicos, quedarán regidos por estas reglas y sometidas a la legislación.
                <br />
                <br />En consecuencia, todas las visitas que realice EL USUARIO, en esta página, así como sus efectos jurídicos, quedarán regidos por estas reglas y sometidas a la legislación.
                <br />
                <br />La aceptación de los presentes Términos y Condiciones es imprescindible para el registro, acceso, uso, operación, reserva, búsqueda y toda actividad que realice EL USUARIO, quien declara haber leído y aceptado lo estipulado en el presente documento.
                <br />
                <br />Se informa que los datos personales proporcionados a FONDOS COLECTIVOS quedan incorporados al Banco de Datos denominado “CLIENTES” inscrito en el Registro Nacional de Protección de Datos Personales con Código: “En proceso” de titularidad de FONDOS COLECTIVOS, quien utilizará dicha información para efectos de la gestión de los productos y/o servicios solicitados y/o contratados (incluyendo evaluaciones financieras, procesamiento de datos, formalizaciones contractuales, cobro de deudas, gestión de operaciones financieras y remisión de correspondencia, entre otros), la misma que podrá ser realizada a través de terceros.
                <br />
                <br />FONDOS COLECTIVOS protege estos bancos de datos y sus tratamientos con todas las medidas necesarias para garantizar su seguridad y evitar la alteración, pérdida, tratamiento o acceso no autorizado.
                <br />
                <br />A continuación, se exponen dichos Términos y Condiciones:

                <br /><br /><strong>1. El Usuario:</strong>
                <br />
                <br />A. De su Registro:
                <br />Será necesaria para el uso de los productos ofrecidos por FONDOS COLECTIVOS la aceptación de las presentes condiciones y el registro por parte de EL USUARIO de los diversos datos personales, tales como: nombres y apellidos, tipo y documento nacional de identidad, correo electrónico, número de celular y otros según corresponda. Asimismo, EL USUARIO declara que información brindada es veraz, actual, suficiente y autentica.
                <br />
                <br />B. Derechos al acceder a la Página Web
                <br />
                <br />FONDOS COLECTIVOS garantiza que EL USUARIO gozará de todos los derechos que le reconoce la legislación sobre protección al consumidor y protección de datos personales vigentes en el Perú.
                <br />
                <br />La sola visita a esta página no impone a EL USUARIO a la adquisición de los diversos productos, a menos que haya aceptado las condiciones ofrecidas por FONDOS COLECTIVOS.
                <br />
                <br />FONDOS COLECTIVOS garantiza en particular que la información sobre las características y condiciones de los productos ofrecidos a través de esta Página Web será oportuna, suficiente, veraz, apropiada y de fácil acceso a EL USUARIO. Dicha información podrá ser modifica por FONDOS COLECTIVOS, incluyendo la relacionada a las características y condiciones de cada servicio, en cualquier momento y sin previo aviso.
                <br />
                <br />C. Obligaciones al acceder a la Página Web
                <br />
                <br />EL USUARIO se obliga a acceder a la Página Web, con la mayor diligencia, debiéndose entender que realizará un uso correcto, y lícito, evitando en todo momento realizar acciones que puedan atentar contra el buen funcionamiento y la imagen de FONDOS COLECTIVOS o cualquier acto que vaya en contra de sus fines.
                <br />
                <br />Por ello, EL USUARIO se obliga a:
                <br />(i)  No utilizar el Página Web con fines fraudulentos o no llevar a cabo una conducta que, involucrando a la Página Web, dañe o genere un daño a la imagen, los intereses y los derechos de FONDOS COLECTIVOS o de terceros
                <br />(ii) No suprimir, eludir o manipular el "copyright" y demás datos identificativos de los derechos de sus titulares incorporados a los contenidos en la Página Web
                <br />(iii)  No realizar cualquier acto que involucre dañar, inutilizar o sobrecargar el Página Web, o que impidiera, de cualquier forma, la normal utilización y funcionamiento del mismo.
                <br />
                <br />
                <br />Esta lista debe ser entendida como enunciativa más no limitativa, pudiendo extenderse a cualquier acto realizado por EL USUARIO que conlleve a lograr el perjuicio a FONDOS COLECTIVOS, a sus clientes u otros Usuarios o proveedores.
                <br />En caso FONDOS COLECTIVOS detecte que EL USUARIO realizó cualquiera de las prohibiciones nombradas en el párrafo anterior o incluso cuando existan indicios o sospechas razonables de ellas, limitará, suspenderá o dará por concluido el acceso de EL USUARIO a la Página Web. Aunado a ello, FONDOS COLECTIVOS adoptará las acciones legales y técnicas necesarias.
                <br />
                <br /><strong>2. Limitación de responsabilidad</strong>
                <br />
                <br />EL USUARIO reconoce y acepta que el acceso a la Página Web se realiza en todo momento bajo su riesgo y responsabilidad, por lo que FONDOS COLECTIVOS no se responsabiliza del mal uso o acceso indebido que pueda realizarse del mismo. Por tanto, FONDOS COLECTIVOS no será responsable de lo siguiente:
                <br />
                <br />• El contenido de las páginas enlazados a través de los enlaces (links) incluidos dentro del Página Web.
                <br />
                <br />• De los contenidos publicitarios que estén albergados en la Página Web.
                <br />En ningún caso FONDOS COLECTIVOS será responsable de la inexactitud, falsedad, irregularidades y/o actos que puedan considerarse contrarios a la moral, usos y buenas costumbres que puedan contener los materiales publicitarios de los anunciantes; quienes asumen directamente toda responsabilidad.
                <br />
                <br />• Los daños y perjuicios de cualquier tipo causados en los equipos informáticos de EL USUARIO por virus, gusanos informáticos, troyanos o cualquier otro elemento dañino.
                <br />
                <br />• Los daños y perjuicios de cualquier tipo producidos por fallos o desconexiones en las redes de telecomunicaciones que produzcan la suspensión, cancelación o interrupción del acceso a la Página Web. EL USUARIO reconoce que el acceso al Página Web requiere de servicios suministrados por terceros ajenos al control de FONDOS COLECTIVOS.
                <br />
                <br /><strong>3. Fuerza mayor</strong>
                <br />
                <br />FONDOS COLECTIVOS no será responsable de cualquier incumplimiento o retraso en el cumplimiento de las diversas obligaciones señaladas en los presentes documento, cuando ello sea causado por un hecho que escape de su control, caso fortuito, hecho determinante de terceros o causado por fuerza mayor.
                <br />
                <br />Se debe entender por “fuerza mayor” a cualquier acto o hecho extraordinario, imprevisible e irresistible que impide la ejecución de la obligación parcial, tardía o defectuosa por parte de FONDOS COLECTIVOS, incluyendo, sin limitación, a conmoción civil, disturbios, invasión, ataque terrorista o amenaza de ataque terrorista, guerra (declarada o no) huelgas u otras medidas realizadas por terceros, o acciones realizadas por un proveedor generando retraso, incendio, explosión, tormenta, inundación, terremoto, hundimiento, epidemia, endemia, pandemia o cualquier otro desastre natural, o el fracaso de las redes de telecomunicaciones públicas o privadas.
                <br />
                <br />De darse un evento de fuerza mayor que afecte al cumplimiento de las obligaciones de FONDOS COLECTIVOS, las obligaciones pactadas y plazos serán automáticamente suspendidos hasta la culminación de los hechos referidos. Una vez superado el evento de fuerza mayor los plazos continuarán con su cómputo.
                <br />
                <br /><strong>4. Enlaces (links)</strong>
                <br />
                <br />La Página Web puede incluir enlaces (links) que permitan a EL USUARIO a acceder a otras páginas y portales de Internet. En estos casos, FONDOS COLECTIVOS actúa como un prestador de servicios a terceros. En el supuesto de que EL USUARIO considere que existe una página enlazada con contenidos inadecuados o ilícitos, deberá comunicarlo a FONDOS COLECTIVOS a través del formulario de contacto con la finalidad de evaluar el caso y definir las acciones correctivas necesarias.
                <br />
                <br />FONDOS COLECTIVOS no se hace responsable del contenido de las páginas enlazados, ni de sus condiciones de uso y/o políticas de privacidad ni similares, siendo EL USUARIO el único responsable de comprobarlos y aceptarlos cada vez que acceda y haga uso de los mismos.
                <br />
                <br />FONDOS COLECTIVOS se reserva el derecho a prohibir o inutilizar en cualquier momento los enlaces publicados en la Página Web.
                <br />
                <br /><strong>5. Validez de la publicidad contenida en el este Página Web</strong>
                <br />
                <br />La publicidad de los productos que realice FONDOS COLECTIVOS se rige por las disposiciones del Código de Protección de Defensa del Consumidor y otras normas que resulten aplicables.
                <br />
                <br />En cada anuncio promocional se indicará de manera clara la vigencia, stock y condiciones adicionales del servicio promocionado.
                <br />
                <br />FONDOS COLECTIVOS se reserva el derecho de poder modificar el contenido de la Página Web, incluyendo aquella información relacionada a los productos, en cualquier momento y sin mediar previo aviso. Por tanto, en caso EL USUARIO haya seleccionado un producto o servicio sujeto a alguna promoción y/u oferta, y la misma quedará sin efecto antes de la conclusión de la transacción, la selección de dicho producto o servicio también concluirá.
                <br />
                <br />La facultad de modificar las condiciones por parte de FONDOS COLECTIVOS no se aplicará a aquellas transacciones que se hayan realizado con éxito y que hayan sido confirmadas por la Página Web, a menos que se trate de un error obvio e inequívoco, en cuyo caso se aplicará lo dispuesto por el párrafo anterior.
                <br />
                <br /><strong>6. Propiedad intelectual</strong>
                <br />
                <br />Los derechos de propiedad intelectual sobre la disposición de los contenidos de la Página Web (incluidos los derechos conexos), su diseño gráfico, los signos distintivos (marcas y nombres comerciales), así como los programas de ordenador subyacentes (incluidos los códigos fuente) son de exclusiva titularidad de FONDOS COLECTIVOS, por tanto, el derecho de uso y explotación de estos, son protegidas por la legislación de propiedad intelectual e industrial vigentes.
                <br />
                <br />Respecto a los distintos elementos que integran el portal (gráficos, fotografías, videos, etc.) el derecho de uso y explotación de los mismos corresponden al Grupo Santander, del cual es parte FONDOS COLECTIVOS, y son protegidas por la legislación de propiedad intelectual e industrial vigentes.
                <br />
                <br />Queda expresamente prohibido la reproducción, transformación, distribución, comunicación pública, puesta a disposición, extracción y/o reutilización de la Página Web, sus contenidos y/o los signos distintivos de FONDOS COLECTIVOS.
                <br />
                <br /><strong>7. Imágenes referenciales de los productos o servicios financieros</strong>
                <br />
                <br />EL USUARIO debe tener en cuenta que las fotografías, videos, representaciones graficas de los productos mostrados en la Página Web, tienen una finalidad orientadora y referencial.

                <br />   <br />

                <br />
                <span className="subtitulos"> PROTECCIÓN DE DATOS:</span>
                <br />

                <br />              FONDOS COLECTIVOS cumple con informar que, de acuerdo con la Ley N°29733 - Ley de Protección de Datos Personales y su Reglamento aprobado mediante Decreto Supremo N° 003-2013-JUS y las demás disposiciones complementarias, está legalmente autorizada para tratar la información que EL USUARIO proporcionará mediante el presente Página Web, con la finalidad de ejecutar la relación contractual.
                <br />
                <br />Asimismo, FONDOS COLECTIVOS informa que para dar cumplimiento a las obligaciones y/o requerimientos que se generen en virtud de las normas vigentes en el ordenamiento jurídico peruano y/o en normas internacionales que le sean aplicables, incluyendo, pero sin limitarse a las vinculadas al sistema de prevención de lavado de activos y financiamiento del terrorismo, FONDOS COLECTIVOS podrá dar tratamiento y eventualmente transferir su información a autoridades y terceros autorizados por ley.
                <br />
                <br />EL USUARIO reconoce que estarán incluidos dentro de su información todos aquellos datos, operaciones y referencias a los que FONDOS COLECTIVOS pudiera acceder en el curso normal de su relación, ya sea por haber sido proporcionados por Usted o por terceros o por haber sido desarrollados por FONDOS COLECTIVOS, tanto en forma física, oral, electrónica y cualquier otro mecanismo, y que pudieran calificar como Datos Personales conforme a la legislación de la materia.
                <br />
                <br />En virtud de lo señalado, FONDOS COLECTIVOS a incorporar su información al Banco de Datos denominado “CLIENTES” inscrito en el Registro Nacional de Protección de Datos Personales con Código “en proceso”, así como almacenará, dará tratamiento, procesar y/o transferir su información a sus socios comerciales que figuran en la política de privacidad anteriormente mencionada, conforme a los procedimientos que FONDOS COLECTIVOS determine en el marco de sus operaciones habituales, hasta diez (10) años después de que finalice su relación contractual.
                <br />

                <br />

                <br />


              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <p className="Columna">
                  Países y Gobiernos sancionados
                </p>
              </Col>
              <Col md={8}>

                <Row style={{ marginTop: 10 }}>
                  <div className="card-style-transparence"  >
                    <div style={{ width: "100%" }}>
                      <span className="parrafo">

                        Extracto Política Sanciones y Contramedidas Financieras
                      </span>
                    </div>
                    <div style={{ width: "40%" }}>
                      <SurgirItemListWithIcon icon={DownloadIconTab} document={process.env.REACT_APP_REPORTE_SANCIONES_Y_CONTRAMEDIDAS}
                        name={<span className="linkrojo" style={{ color: '#EC0000' }}> Descargar</span>} downloadName={"Terminos"} />
                    </div>
                  </div>
                </Row>
                <br />

                <br />
              </Col>
            </Row>
          </Tab>


          <Tab
            eventKey="Reclamos-y-Requerimientos"
            title="Requerimientos y Reclamos"
            style={{ marginLeft: "10%", marginRight: "10%" }}
          >
            <Row>
              <Col md={4}>
                <p className="Columna">Reclamos y Requerimientos</p>
              </Col>
              <Col md={8}>
                <span className="subtitulos">¿Qué es un reclamo?</span>
                <p>
                  <br />Es una comunicación presentada por el usuario o tercero a nombre
                  del usuario, a través de los diferentes canales de atención
                  disponibles, expresando su insatisfacción con la operación,
                  servicio y/o producto recibido o por incumplimiento de las
                  obligaciones contempladas en los contratos o norma vigente, o
                  manifestando la presunta afectación de su legítimo interés.
                </p>

                <br /><br />
                <span className="subtitulos">¿Qué es un requerimiento?</span>
                <p>
                  <br />              Es una comunicación presentada por un usuario o tercero a nombre del usuario, mediante la cual se busca una acción por parte de la empresa. Los requerimientos comprenden la atención de:
                  <br /><br />A. Consultas
                  <br />Comunicaciones por las que se busca que SANTANDER FONDOS COLECTIVOS proporcione determinada información ante una situación de incertidumbre, desconocimiento o duda relacionada a la operación, producto o servicio ofrecido o contratado con SANTANDER FONDOS COLECTIVOS.
                  <br />
                  <br />B. Solicitudes
                  <br />Solicitud de entrega o puesta a disposición de información que SANTANDER FONDOS COLECTIVOS posee sobre la relación que mantiene o mantuvo con los usuarios.
                  <br />
                  <br />C. Otras solicitudes
                  <br />Distintas a las indicadas en el punto B y que no se encuentre en lo siguientes supuestos:
                  <br />i. Aspectos relacionados a atención de reclamos.
                  <br />ii. Aspectos propios de la ejecución del contrato.
                  <br />iii. Contratación de nuevos productos o servicios.
                </p>

                <br /><br />
              </Col>
            </Row>

          </Tab>
          <Tab
            eventKey="reporte"
            title="Vendedores Autorizados"
            style={{ marginLeft: "10%", marginRight: "10%" }}
          >
            <Row style={{ padding: 0 }}>
              <Col md={4}>
                <p className="Columna">Vendedores Autorizados</p>
              </Col>
              <Col md={8}>
                <Card body style={{ paddingLeft: 25 }}>
                  {" "}

                  <Row>
                    <Col md={9}>
                      Vendedores Autorizados
                    </Col>
                    <Col md={3}>
                      <a
                        className="Descarga"
                        style={{ textDecoration: "none", color: "#767676" }}
                        href={process.env.REACT_APP_VENDEDORES}
                        rel="noopener noreferrer"
                        target="_blank"
                        download="Tema_1"
                      >
                        {" "}
                        <DownloadIcon /> Descargar{" "}
                      </a>
                    </Col>
                  </Row>
                </Card>
                <br />

              </Col>
            </Row>

          </Tab>
          <Tab
            eventKey="cont"
            title="Política de Clientes Vulnerables"
            style={{ marginLeft: "10%", marginRight: "10%" }}
          >
            <Row style={{ padding: 0 }}>
              <Col md={4}>
                <p className="Columna">Política de Clientes Vulnerables</p>
              </Col>
              <Col md={8}>
                <Card body style={{ paddingLeft: 25 }}>
                  {" "}

                  <Row>
                    <Col md={9}>
                      Procedimiento de Atención de Clientes Vulnerables
                    </Col>
                    <Col md={3}>
                      <a
                        className="Descarga"
                        style={{ textDecoration: "none", color: "#767676" }}
                        href={process.env.REACT_APP_CLIENTES_VULNERABLES}
                        rel="noopener noreferrer"
                        target="_blank"
                        download="Tema_1"
                      >
                        {" "}
                        <DownloadIcon /> Descargar{" "}
                      </a>
                    </Col>
                  </Row>
                </Card>
                <br />

              </Col>
            </Row>
          </Tab>
          <Tab
            eventKey="DerechosArco"
            title="Derechos Arco"
            style={{ marginLeft: "10%", marginRight: "10%" }}
          >
            <Row style={{ padding: 0 }}>
              <Col md={4}>
                <p className="Columna">Derechos Arco</p>
              </Col>
              <Col md={8}>
                <Card body style={{ paddingLeft: 25 }}>
                  {" "}
                  <Row>
                    <Col md={9}>
                      Atención de Derechos ARCO
                    </Col>
                    <Col md={3}>
                      <a
                        className="Descarga"
                        style={{ textDecoration: "none", color: "#767676" }}
                        href={process.env.REACT_APP_DERECHOS_ARCO}
                        rel="noopener noreferrer"
                        target="_blank"
                        download="Tema_1"
                      >
                        {" "}
                        <DownloadIcon /> Descargar{" "}
                      </a>
                    </Col>
                  </Row>
                </Card>
                <br />
                <Card body style={{ paddingLeft: 25 }}>
                  <Row>
                    <Col md={9}>
                      SOLICITUD DE DERECHOS DEL TITULAR DE DATOS PERSONALES
                    </Col>
                    <Col md={3}>
                      <a
                        className="Descarga"
                        style={{ textDecoration: "none", color: "#767676" }}
                        href={process.env.REACT_APP_SOLICITUD_DERECHOS_DATOS}
                        rel="noopener noreferrer"
                        target="_blank"
                        download="Tema_1"
                      >
                        {" "}
                        <DownloadIcon /> Descargar{" "}
                      </a>
                    </Col>
                  </Row>
                </Card>
                <br />

              </Col>
            </Row>
          </Tab>


          <Tab
            eventKey="educacionfinanciera"
            title="Información financiera"
            style={{ marginLeft: "10%", marginRight: "10%" }}
          >
            <Row style={{ padding: 0 }}>
              <Col md={4}>
                <p className="Columna">Portal de la Superintendencia del Mercado de Valores</p>
              </Col>
              <Col md={8}>
                <br />
                <span>Visita la página web de la SMV</span>  <a target="blank" href=" https://www.smv.gob.pe/SIMV/Frm_LisDatosGenerales?data=BE27B4E69C41BEE8D73C06548896D1C39A49AA2BD9">click aquí</a>.

                <br />

              </Col>
            </Row>
          </Tab>


        </Tabs>
      </div>
    </div>
  );
}

export default Transparency
